import React from "react";
import ProductTemplate from "../../ProductTemplate";
import s77Cover from "../../../assets/s77/S77Cover.png";
import s77a from "../../../assets/s77/s77a.webp";
import s77b from "../../../assets/s77/s77b.webp";
import s771 from "../../../assets/s77/s771.webp";
import s772 from "../../../assets/s77/s772.webp";
import s773 from "../../../assets/s77/s773.webp";
import s774 from "../../../assets/s77/s774.webp";
import s775 from "../../../assets/s77/s775.webp";
import s776 from "../../../assets/s77/s776.webp";
import s777 from "../../../assets/s77/s777.webp";
import s778 from "../../../assets/s77/s778.webp";
import s779 from "../../../assets/s77/s779.webp";
import s77sec1 from "../../../assets/s77/s77sec1.webp";
import s77sec2 from "../../../assets/s77/s77sec2.webp";
import s77sec3 from "../../../assets/s77/s77sec3.webp";

const S77 = () => {
  const data = {
    title: "ALUMIL S77",
    subtitle: "Hinged insulated system SMARTIA S77",
    description:
      "The system SMARTIA S77 is ALUMIL's proposal for advanced insulating casements, which meet the high standards of all advanced markets and incorporate a modern design. It is the ideal solution for projects that require high performance and maximum security.",
    specifications: [
      { label: "WINDOW TYPE", value: "Hinged" },
      { label: "FRAME DEPTH", value: "77 mm" },
      { label: "U-VALUE", value: "from 0.85 to 2.42 W/m²K" },
      { label: "BURGLAR RESISTANCE", value: "RC2/RC3" },
      { label: "WATER TIGHTNESS", value: "CLASS E1350" },
      { label: "AIR PERMEABILITY", value: "CLASS 4" },
      { label: "MAXIMUM GLAZING THICKNESS", value: "up to 72 mm" },
      { label: "MINIMUM VISIBLE ALUMINIUM FACE HEIGHT", value: "93 mm" },
    ],
    renders: [s77Cover, s77a, s77b],
    typologies: [
      { image: s771, caption: "Odd number of vents on one side" },
      { image: s772, caption: "Odd number of vents plus door" },
      { image: s773, caption: "Odd number of vents on both sides (meeting stile)" },
      { image: s774, caption: "Odd number of vents on one side" },
      { image: s775, caption: "Corner construction with single door" },
      { image: s776, caption: "Corner construction with odd number of vents on both sides" },
      { image: s777, caption: "Odd number of vents on both sides (meeting stile)" },
      { image: s778, caption: "Even number of vents on one side" },
      { image: s779, caption: "Even number of vents plus door" },
    ],
    sections: [s77sec1, s77sec2, s77sec3],
    relatedFiles: [
      {
        label: "S77 System Specs",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/pre-qualification-files/supreme/pre-qualification-sd77f4e3a81aba954c1b8c233f00e0788cd4.pdf?sfvrsn=2ebdd2d8_31",
      },
      {
        label: "S77 Brochure",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/technical/supreme/smartia-s77-en.pdf?sfvrsn=9f4a77ee_59",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default S77;